import { useApp } from '../context.js';
import { restaurantStats, getLastVisited, isVisited, wantToTryState } from '../lib/visits.js';
import { CUISINE_BY_ID, VIBE_BY_ID } from '../lib/categories.js';
import { Star } from '../icons.jsx';

const WANT_LABEL = { doug: '🙋 Doug wants to try', les: '🙋 Les wants to try', both: '💛💖 Both want to try!' };

export default function CardChips({ restaurant }) {
    const { t } = useApp();
    const stats = restaurantStats(restaurant);
    const lastVisited = getLastVisited(restaurant);
    const want = wantToTryState(restaurant);
    const checks = restaurant.checks || [];
    const tags = [
        ...(restaurant.cuisine || []).map((id) => CUISINE_BY_ID[id]).filter(Boolean),
        ...(restaurant.vibe || []).map((id) => VIBE_BY_ID[id]).filter(Boolean),
    ];
    return (
        <>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
                {typeof stats.avgRating === 'number' && (
                    <div className={`flex items-center gap-1 ${t.accentBg} px-2 py-1 rounded-full`}>
                        <Star size={14} className="text-yellow-500 fill-yellow-500" />
                        <span className="text-sm font-semibold text-gray-700">
                            {stats.avgRating}/10
                            {stats.hasVisits && <span className="text-xs ml-1">({stats.visitCount} {stats.visitCount === 1 ? 'visit' : 'visits'})</span>}
                        </span>
                    </div>
                )}
                {checks.length > 0 && (
                    <span className="text-xs text-gray-500">
                        💰 {checks.length}
                    </span>
                )}
                {/* Last Visited Display */}
                {lastVisited && (
                    <div className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded-full">
                        <span className="text-xs font-medium text-blue-700">
                            🕒 {lastVisited}
                        </span>
                    </div>
                )}
                {!isVisited(restaurant) && typeof restaurant.rating === 'number' && (
                    <div className="flex items-center gap-1 bg-purple-50 px-2 py-1 rounded-full">
                        <span className="text-xs font-medium text-purple-700">
                            ⭐ Rated
                        </span>
                    </div>
                )}
                {want !== 'none' && !isVisited(restaurant) && (
                    <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${want === 'both' ? 'bg-pink-100' : 'bg-amber-50'}`}>
                        <span className={`text-xs font-semibold ${want === 'both' ? 'text-pink-700' : 'text-amber-700'}`}>{WANT_LABEL[want]}</span>
                    </div>
                )}
            </div>
            {tags.length > 0 && (
                <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
                    {tags.map((p) => (
                        <span key={p.id} className="text-xs text-gray-600 bg-gray-100 px-2 py-0.5 rounded-full">{p.emoji} {p.label}</span>
                    ))}
                </div>
            )}
        </>
    );
}
